import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function usePatchNoteAuthor() {
  const { data, _error, isLoading, isValidating, mutate } = useSWR(
    `/patchnote/author`,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    authors: data,
    isLoading: isLoading,
    isValidating: isValidating,
    mutateAuthor: mutate,
  };
}

export default usePatchNoteAuthor;
